import dynamic from 'next/dynamic';
import {
  HotelTileGroupContainer,
  PopularHotelsContainer,
  SpecialOffersContainer,
  HolidaysCallToBookContainer
} from '@components/content/fit';

import {
  BenefitsGroupContainer,
  BreadcrumbContainer,
  CallToBookContainer,
  ExpandableListContainer,
  HeroContainer,
  IntroContainer,
  PageSeoContainer,
  RecentlyViewedContainer,
  TabGroupContainer,
  TestimonialsContainer,
  TextContainer,
  TitleContainer,
  TrustPilotContainer
} from '@components/content/common';
import {
  ClimateDataContainer,
  DestinationFaqContainer,
  DestinationListContainer,
  DestinationsGroupContainer,
  ResortsListContainer,
  TestimonialContentContainer,
  TravelGuideContainer,
  VideoGuideContainer
} from '@components/content/destination';
import { TourDestinationContainer, TourGroupContainer, ToursCallToBookContainer } from '@components/content/tours';
import { RecentlyViewedCarouselContainer } from '@components/recently-viewed/RecentlyViewedCarouselContainer';
import { withSeparators } from '@components/hoc/dynamic-components';
import { Separator } from '@styles/layout';

const DynamicAllInclusiveOffersCountryList = dynamic(
  () =>
    import('../../src/components/content/offers/AllInclusiveOffersCountryListContainer').then(
      (e) => e.AllInclusiveOffersCountryListContainer
    ),
  {
    ssr: false
  }
);

const DynamicPageTileGroupContainer = dynamic(
  () => import('../components/content/offers/PageTileGroupContainer').then((e) => e.PageTileGroupContainer),
  {
    ssr: false
  }
);

export enum ComponentHandles {
  ALL_INCLUSIVE_OFFERS_COUNTRY_LIST = 'allInclusiveOffersCountryList',
  BENEFIT_GROUP = 'benefitGroup',
  BREADCRUMBS = 'breadcrumbs',
  CALL_TO_BOOK = 'callToBook',
  CLIMATE_DATA = 'climateData',
  DESTINATION_GROUP = 'destinationGroup',
  DESTINATION_FAQ = 'destinationFaq',
  DESTINATION_LIST = 'destinationList',
  EXPANDABLE_LIST_GROUP = 'expandableListGroup',
  EXPLORE_DESTINATION = 'exploreDestination',
  HERO_IMAGE = 'heroImage',
  HOLIDAYS_CALL_TO_BOOK = 'holidaysCallToBook',
  HOTEL_TILE_GROUP = 'hotelTileGroup',
  INTRO = 'intro',
  PAGE_SEO = 'pageSeo',
  PAGE_TILE_GROUP = 'pageTileGroup',
  POPULAR_HOTELS = 'popularHotels',
  RECENTLY_VIEWED = 'recentlyViewed',
  RESORTS_LIST = 'resortsList',
  SEPERATOR = 'separator',
  SPECIAL_OFFERS = 'specialOffers',
  TAB = 'tab',
  TAB_GROUP = 'tabGroup',
  TESTIMONIALS = 'testimonials',
  TESTIMONIALS_COMPONENT = 'testimonialsComponent',
  TEXT = 'text',
  TITLE = 'title',
  TOUR_DESTINATION = 'tourDestination',
  TOUR_GROUP = 'tourGroup',
  TOURS_CALL_TO_BOOK = 'toursCallToBook',
  TRAVEL_GUIDE_TILES = 'travelGuideTiles',
  TRUST_PILOT = 'trustPilot',
  YOUR_RECENTLY_VIEWED = 'yourRecentlyReviewed',
  VIDEO_GUIDE_TILES = 'videoGuideTiles'
}

export const ComponentTypes = new Map();

ComponentTypes.set(ComponentHandles.ALL_INCLUSIVE_OFFERS_COUNTRY_LIST, DynamicAllInclusiveOffersCountryList);
ComponentTypes.set(ComponentHandles.BENEFIT_GROUP, withSeparators(BenefitsGroupContainer));
ComponentTypes.set(ComponentHandles.BREADCRUMBS, withSeparators(BreadcrumbContainer));
ComponentTypes.set(ComponentHandles.CALL_TO_BOOK, withSeparators(CallToBookContainer));
ComponentTypes.set(ComponentHandles.CLIMATE_DATA, withSeparators(ClimateDataContainer));
ComponentTypes.set(ComponentHandles.DESTINATION_GROUP, withSeparators(DestinationsGroupContainer));
ComponentTypes.set(ComponentHandles.DESTINATION_FAQ, withSeparators(DestinationFaqContainer));
ComponentTypes.set(ComponentHandles.DESTINATION_LIST, withSeparators(DestinationListContainer));
ComponentTypes.set(ComponentHandles.EXPANDABLE_LIST_GROUP, withSeparators(ExpandableListContainer));
ComponentTypes.set(ComponentHandles.EXPLORE_DESTINATION, withSeparators(ResortsListContainer));
ComponentTypes.set(ComponentHandles.HERO_IMAGE, withSeparators(HeroContainer));
ComponentTypes.set(ComponentHandles.HOLIDAYS_CALL_TO_BOOK, withSeparators(HolidaysCallToBookContainer));
ComponentTypes.set(ComponentHandles.HOTEL_TILE_GROUP, withSeparators(HotelTileGroupContainer));
ComponentTypes.set(ComponentHandles.INTRO, withSeparators(IntroContainer));
ComponentTypes.set(ComponentHandles.HOTEL_TILE_GROUP, withSeparators(HotelTileGroupContainer));
ComponentTypes.set(ComponentHandles.PAGE_SEO, PageSeoContainer);
ComponentTypes.set(ComponentHandles.PAGE_TILE_GROUP, DynamicPageTileGroupContainer);
ComponentTypes.set(ComponentHandles.POPULAR_HOTELS, withSeparators(PopularHotelsContainer));
ComponentTypes.set(ComponentHandles.RECENTLY_VIEWED, withSeparators(RecentlyViewedCarouselContainer));
ComponentTypes.set(ComponentHandles.RESORTS_LIST, withSeparators(ResortsListContainer));
ComponentTypes.set(ComponentHandles.SEPERATOR, Separator);
ComponentTypes.set(ComponentHandles.SPECIAL_OFFERS, withSeparators(SpecialOffersContainer));
ComponentTypes.set(ComponentHandles.TAB_GROUP, withSeparators(TabGroupContainer));
ComponentTypes.set(ComponentHandles.TESTIMONIALS, withSeparators(TestimonialsContainer));
ComponentTypes.set(ComponentHandles.TESTIMONIALS_COMPONENT, withSeparators(TestimonialContentContainer));
ComponentTypes.set(ComponentHandles.TEXT, withSeparators(TextContainer));
ComponentTypes.set(ComponentHandles.TITLE, withSeparators(TitleContainer));
ComponentTypes.set(ComponentHandles.TOUR_DESTINATION, withSeparators(TourDestinationContainer));
ComponentTypes.set(ComponentHandles.TOUR_GROUP, withSeparators(TourGroupContainer));
ComponentTypes.set(ComponentHandles.TOURS_CALL_TO_BOOK, withSeparators(ToursCallToBookContainer));
ComponentTypes.set(ComponentHandles.TRAVEL_GUIDE_TILES, withSeparators(TravelGuideContainer));
ComponentTypes.set(ComponentHandles.TRUST_PILOT, withSeparators(TrustPilotContainer));
ComponentTypes.set(ComponentHandles.YOUR_RECENTLY_VIEWED, withSeparators(RecentlyViewedContainer));
ComponentTypes.set(ComponentHandles.VIDEO_GUIDE_TILES, withSeparators(VideoGuideContainer));
